<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

defineProps<{ app: string }>();
const route = useRoute();
const sourcePage = computed(() => `https://mysimplebible.com${route.path}`);
</script>

<template>
  <section id="contact" class="contact-band" aria-labelledby="contact-heading">
    <div class="contact-intro">
      <p class="eyebrow">Contact support</p>
      <h2 id="contact-heading">Let’s work it out.</h2>
      <p>Tell us what happened and which device you use. Include the steps that led to the problem so we can help.</p>
      <span class="contact-app">{{ app }} support</span>
    </div>
    <form class="contact-form" action="https://usebasin.com/f/3bea79da29b5" method="post" accept-charset="UTF-8">
      <input type="hidden" name="app" :value="app" />
      <input type="hidden" name="source" :value="`${app} website`" />
      <input type="hidden" name="source_page" :value="sourcePage" />
      <div class="contact-honeypot" aria-hidden="true">
        <label>Leave this field empty<input name="_gotcha" tabindex="-1" autocomplete="off" /></label>
      </div>
      <label class="contact-field"><span>Name</span><input name="name" type="text" autocomplete="name" maxlength="150" required /></label>
      <label class="contact-field"><span>Email</span><input name="email" type="email" autocomplete="email" inputmode="email" maxlength="254" required /></label>
      <label class="contact-field contact-field--wide"><span>Device <small>Optional</small></span>
        <select name="device"><option value="">Choose your device</option><option>iPhone or iPad</option><option>Android</option><option>Website</option><option>Other</option></select>
      </label>
      <label class="contact-field contact-field--wide"><span>Message</span><textarea name="message" rows="5" maxlength="10000" required></textarea></label>
      <div class="contact-actions">
        <p class="contact-note">We use these details to respond to your message. <RouterLink to="/privacy-policy/">Read our privacy policy</RouterLink>.</p>
        <button class="button button--primary" type="submit">Send message <span aria-hidden="true">↗</span></button>
      </div>
    </form>
  </section>
</template>
